import { mediaRef } from '@/services/mediaAssets';
import {
  conferenceGalleries,
  corporateRetreatGalleries,
} from '@/data/adventureGalleries';
import { reckonBallByYear } from '@/content/reckon-ball';
import { anniversaryDinner } from '@/content/culture/traditions';
import { welcomeToReckonWayStory } from '@/content/culture/stories';

const featuredFallbackImage = mediaRef('adventures/reckon-way-featured-fallback.png');
const reckonBall2025GroupPhoto = mediaRef('adventures/reckon-ball-2025-group-photo.png');
const icelandGroupPhoto = mediaRef('adventures/iceland-blog/iceland-group-viking-hats.jpg');
const sydneyCoastPhoto = mediaRef('adventures/sydney-bondi-coogee-coastline.jpg');
const londonBarbicanPhoto = mediaRef('adventures/london-barbican-centre.jpg');

function findGallery(galleries, slug) {
  return galleries.find((gallery) => gallery.slug === slug);
}

const sydney = findGallery(conferenceGalleries, 'sxsw-sydney-2025');
const london = findGallery(conferenceGalleries, 'sxsw-london-2025');
const iceland = findGallery(corporateRetreatGalleries, 'iceland-corporate-retreat-2026');
const reckonBall2025 = reckonBallByYear[2025];
const anniversaryDinner2025 = anniversaryDinner.occurrences.find(
  (occurrence) => occurrence.id === 'anniversary-dinner-2025',
);

/** @type {import('./types').FeaturedContentItem[]} */
export const featuredContentItems = [
  {
    ...welcomeToReckonWayStory,
    image: featuredFallbackImage,
    imageAlt: 'A Reckon hero overlooking a mountain landscape at sunset',
  },
  {
    id: iceland.slug,
    title: iceland.title,
    slug: iceland.slug,
    href: `/the-reckon-way/${iceland.slug}`,
    excerpt: iceland.summary,
    image: icelandGroupPhoto,
    imageAlt: 'The Reckon Crew and their families together on Iceland’s snowy coastline',
    contentType: 'retreat',
    location: 'Iceland',
    eventDate: iceland.dateLabel,
    publishedAt: '2026-07-01',
    featured: true,
    featuredPriority: 1,
  },
  {
    id: 'reckon-ball-2025',
    title: 'Reckon Ball 2025',
    slug: reckonBall2025.slug,
    href: '/the-reckon-way/reckon-ball/2025',
    excerpt: reckonBall2025.hero.summary,
    image: reckonBall2025GroupPhoto,
    imageAlt: 'Reckon Crew and guests gathered at Reckon Ball 2025',
    contentType: 'reckon-ball',
    location: 'Washington, D.C.',
    eventDate: 'December 2025',
    publishedAt: '2026-06-24',
    featured: true,
    featuredPriority: 2,
  },
  {
    id: sydney.slug,
    title: sydney.title,
    slug: sydney.slug,
    href: `/the-reckon-way/${sydney.slug}`,
    excerpt: sydney.summary,
    image: sydneyCoastPhoto,
    imageAlt: 'Rocky coastline and ocean along Sydney’s coastal walk',
    contentType: 'conference',
    location: 'Sydney, Australia',
    eventDate: sydney.dateLabel,
    publishedAt: '2026-06-20',
    featured: true,
    featuredPriority: 3,
    badge: 'Crew Favorite',
  },
  {
    id: anniversaryDinner2025.id,
    title: anniversaryDinner2025.title,
    slug: anniversaryDinner2025.id,
    href: '/the-reckon-way/traditions/anniversary-dinner',
    excerpt: anniversaryDinner2025.summary,
    contentType: 'tradition',
    location: "Fleming's Prime Steakhouse, Tysons, Virginia",
    eventDate: 'August 2025',
    publishedAt: '2026-06-19',
    featured: true,
    featuredPriority: 4,
  },
  {
    id: london.slug,
    title: london.title,
    slug: london.slug,
    href: `/the-reckon-way/${london.slug}`,
    excerpt: london.summary,
    image: londonBarbicanPhoto,
    imageAlt: 'A SXSW London panel at the Barbican Centre',
    contentType: 'conference',
    location: 'London, United Kingdom',
    eventDate: london.dateLabel,
    publishedAt: '2026-06-18',
    featured: true,
    featuredPriority: 5,
  },
];

export default featuredContentItems;
